<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom et Modèle du produit</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Catégorie</span>
      </div>
      <input disabled type="text" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de création</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de mise à jour</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Prix</span>
      </div>
      <input disabled type="number" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Description</span>
      </div>
      <textarea disabled aria-label="First name" class="form-control"></textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="ville">Monnaie</label>
      </div>
      <select disabled class="custom-select" id="ville">
        <option>Choose...</option>
        <option selected value="1">Kinshasa</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Code du produit</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Réduction</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="etat_produit">Etat du produit</label>
      </div>
      <select disabled class="custom-select" id="etat_produit">
        <option>Choose...</option>
        <option selected value="1">Kinshasa</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Quantité disponible</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Vendeur</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Adresse</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <hr class="bg-dark">
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Réceptionniste</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de création</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm mb-3 d-flex flex-row">
      <div class="">
        <span class="customized-span">Collecté</span>
      </div>
      <div class="ml-3">
        <div class="custom-control custom-radio custom-control-inline">
          <input checked disabled type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input">
          <label class="custom-control-label" for="customRadioInline1">Oui</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input disabled type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input">
          <label class="custom-control-label" for="customRadioInline2">Non</label>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "Read"
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/produits_collectes/components/Read.vue